import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { toast } from 'react-toastify'
import _ from 'lodash'
import firebase from 'firebase'

import SigninBox from './SigninBox'
import { fetchUser } from '../../../actions/auth'
import { FacebookLoginButton } from 'react-social-login-buttons'
import Logo from './Logo'

class SigninContainer extends React.Component {
  state = { redirectToReferrer: false, isAdmin: false }

  componentDidUpdate(prevProps) {
    if (this.props.auth.isLoggedIn && !this.props.auth.isFetching) {
      this.setState({ redirectToReferrer: true })
    }

    if (this.props.auth.error) {
      toast.error(
        <div>
          <p>Incorrect username or password</p>
          <p>
            <small>CODE :{_.get(this.props, 'auth.error.message')}</small>
          </p>
        </div>,
      )
    }
  }

  handleSignin = info => {
    this.props.fetchUser(info)
  }

  handleLoginInWithFacebook = response => {
    console.log('res', response)
    var provider = new firebase.auth.FacebookAuthProvider()
    provider.setCustomParameters({
      display: 'popup',
    })

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        // var token = result.credential.accessToken

        // console.log('result', result)
        // var user = result.user
        // // this.props.fetchUser({
        // //   providerID: user.uid,
        // //   provider: 'facebook',
        // //   username: user.email,
        // //   imageURL: user.photoURL,
        // //   displayName: user.displayName,
        // // })
        return firebase.auth().currentUser.getIdToken(true)
      })
      .then(token =>
        this.props.fetchUser({
          provider: 'facebook',
          token,
        }),
      )
      .catch(error => {
        console.log(error)
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        // The email of the user's account used.
        var email = error.email
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential
        toast.error(error.message)
        // ...
      })
  }

  toggleAdminLogin = event => {
    event.preventDefault()
    this.setState(prevState => ({ isAdmin: !prevState.isAdmin }))
  }

  render() {
    const { redirectToReferrer } = this.state

    if (redirectToReferrer) {
      return <Redirect to={'/'} />
    }

    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          background: '#dddd',
        }}
      >
        <div className="card" style={{ padding: 36 }}>
          <div className="card-content content">
            <Logo />
            <hr />
            <h1>Sign In</h1>
            <FacebookLoginButton onClick={this.handleLoginInWithFacebook} />
            <hr />
            {this.state.isAdmin && <SigninBox onSignin={this.handleSignin} />}
            {!this.state.isAdmin && (
              <div
                className="button has-pulled-right heading"
                onClick={this.toggleAdminLogin}
              >
                admin login
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ auth }) => ({
    auth,
  }),
  { fetchUser: fetchUser },
)(SigninContainer)



// WEBPACK FOOTER //
// ./src/components/templates/signin/SigninContainer.js